module.exports = __webpack_public_path__ + "static/media/snowden-3.81b8fe56.svg";